import { Box, Typography } from "@mui/material";

type Props = {
  title: string;
  isCompleted: boolean;
};

export const Title = ({ title, isCompleted }: Props) => (
  <Box textAlign="center">
    <Typography
      variant="h6"
      component="h3"
      fontWeight={400}
      color={isCompleted ? "success.main" : "primary.main"}
      fontSize="1.1rem"
      lineHeight={1.2}
    >
      {title}
    </Typography>
  </Box>
);
